<template>
  <div>
    <div class="page-content" v-if="answer">
      <div class="content">
        <div class="result-wrap">
          <div class="title">{{answer.subtitle}}</div>
          <div class="text">{{answer.answer}}</div>
        </div>
        <div class="more" @click="moreTest">
          更多小测试 <i class="icon">&#xe61c;</i>
        </div>
        <div class="active-list">
          <div class="item" v-for="(item,index) in answer.funOperations" :key="index">
            <a :href="item.gotoUrl" :style="`background-image: url(${item.imgUrl})`"></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { funQuestionAnswer } from '@/api/adv';

export default {
  name: 'detail',
  data() {
    return {
      answer: undefined,
    };
  },
  created() {
    this.getAnswer();
  },
  methods: {
    getAnswer() {
      const data = {
        subject: this.$route.query.subject,
        score: this.$route.query.score,
      };
      funQuestionAnswer(data)
        .then((res) => {
          this.answer = res;
          window.document.title = res.title;
        });
    },
    moreTest() {
      this.$router.push({
        name: 'ActiveTest',
      });
    },
  },
};
</script>

<style scoped lang="scss">
  .nav-bar{
    box-shadow: 5px 0 15px 2px rgba(0,0,0,0.1);
  }
  .content {
    position: relative;
    width: 100%;
    .result-wrap {
      padding: 48px 70px 60px 70px;

      .title {
        height: 128px;
        line-height: 110px;
        background: rgba(155, 239, 255, 1);
        text-align: center;
        font-size: 48px;
        font-weight: bold;
        color: rgba(0, 0, 0, 1);
        border: 8px solid #000000;
      }

      .text {
        padding: 48px 38px 118px 38px;
        font-size: 32px;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
        border: 8px solid #000000;
        border-top: none;
      }
    }

    .more {
      text-align: center;
      font-size: 34px;
      font-weight: 400;
      color: rgba(0, 0, 0, 1);
      margin-bottom: 52px;
    }

    .active-list {
      padding: 0 16px;

      .item {
        width: 100%;
        height: 260px;
        margin-bottom: 32px;
        border-radius: 18px;
        overflow: hidden;

        a {
          display: block;
          width: 100%;
          height: 100%;
          background-size: cover;
        }
      }
    }
  }
</style>
